module.exports = __webpack_public_path__ + "static/img/device_mini_6.0771f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device_mini_6.png
// module id = xFK/
// module chunks = 16